<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links"/>
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
            <router-link tag="a" :to="{name: 'RegisterPlans'}" class="content--card-register" style="min-height: 200px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="plan in plans.data" :key="plan.id">
            <CardPlans :plan="plan"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardPlans from '@/views/Plans/components/CardPlans';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Planos',
          routerName: 'Plans'
        },
        {
          name: 'Listar Planos',
          routerName: 'ListPlans'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      plans: 'Plans/plans'
    })
  },
  components: {
    Breadcrumb,
    CardPlans
  },
  methods: {
    ...mapActions('Plans', ['consultPlans'])
  },
  mounted() {
    this.consultPlans();
  }
}
</script>

<style lang="scss">
</style>
